define([
    '../base/PureComponent',
    '../utils/CommonUtil'
], function(
    PureComponent,
    CommonUtil
) {
    /**
     * 构造方法
     * @ignore
     * @constructor
     * @classdesc 截屏组件
     * @alias G.components.ScreenShotComponent
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map} options.map - 必填，地图对象
     * @returns {Class} - 实例化的对象
     */
    var component = PureComponent.extend({
        initialize: function(options) {
            PureComponent.prototype.initialize.call(this, options);
            //
        },
        /**
         * 地图截屏
         * @method
         * @memberOf G.components.ScreenShotComponent.prototype
         * @param callback {Function} 必填，回调
         * @example
         * var screenShotCom=new G.components.ScreenShotComponent({map:map});
         * screenShotCom.shotMap(function(base64Str){console.log(base64Str.length);});
         */
        shotMap: function(callback) {
            var element = document.getElementById(this.map.id);
            html2canvas(element, { //
                onrendered: function(canvas) {
                    if (CommonUtil.isFunction(callback)) {
                        callback(canvas.toDataURL());
                    }
                },
                useCORS: true
            });
        },
        /**
         *截屏方法
         */
        screen: function(mapid) {
            html2canvas.download(document.getElementById(this.map.options.targetId));
        },

        /**
         * 组件销毁的方法
         * @method
         * @memberOf G.components.ScreenShotComponent.prototype
         */
        destroy: function() {
            //
            PureComponent.prototype.destroy.call(this);
        }
    });
    return component;
});